import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N20, N40, N70 } from '@atlaskit/theme/colors';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
export var ViewParagraph = function ViewParagraph(_ref) {
  var value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(DisabledParagraphPlaceholder, null, value);
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var DisabledParagraphPlaceholder = styled.div({
  borderStyle: 'solid',
  borderColor: "var(--ds-border-disabled, ".concat(N40, ")"),
  borderRadius: '3px',
  borderWidth: '2px',
  backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
  cursor: 'default',
  padding: "var(--ds-space-075, 6px)",
  minHeight: '100px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1.42857,
  color: "var(--ds-text-disabled, ".concat(N70, ")")
});